// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableManager_tableContainer__33iSa","tableWrapper":"TableManager_tableWrapper__sfZ-8","hideScrollBar":"TableManager_hideScrollBar__SDHok"};